import {
  USGA_POST_BATCH_MAX_ITEMS as SharedUsgaPostBatchMaxItems,
  USGA_POST_BATCH_REASONS as SharedUsgaPostBatchReasons,
  USGA_POST_BATCH_STATUSES as SharedUsgaPostBatchStatuses,
} from "shared/dist/types/UsgaPostBatch";

export type { UsgaPostBatch, UsgaPostBatchItem, UsgaPostBatchStatus } from "shared/dist/types/UsgaPostBatch";

export const USGA_POST_BATCH_MAX_ITEMS = SharedUsgaPostBatchMaxItems;
export const USGA_POST_BATCH_REASONS = SharedUsgaPostBatchReasons;
export const USGA_POST_BATCH_STATUSES = SharedUsgaPostBatchStatuses;
